export const paymentProvider = {
  link: "stripe",
  card: "stripe",
  paypalLink: "paypal"
}
